import * as Sentry from '@sentry/browser'
// import { Integrations } from '@sentry/tracing'

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: 'https://f5cfbe24694e4823adf32474674f013a@o28764.ingest.sentry.io/5720911',
    // integrations: [new Integrations.BrowserTracing()],

    // Configures the sample rate for error events, in the range of 0.0 to 1.0.
    // The default is 1.0 which means that 100% of error events are sent. If set
    // to 0.1 only 10% of error events will be sent. Events are picked randomly.
    sampleRate: 0.2,

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.2,

    // Configure environment with hostname
    environment: window.location.hostname.includes('staging') ? 'staging' : 'production'
  })
}
